import {NgModule} from "@angular/core";
import {CommonModule, LocationStrategy, PathLocationStrategy} from "@angular/common";
import {NgBaseChartComponent} from "./base-chart.component";
import {NgChartComponent} from "./charts/ng-chart.component";
import {NgTooltipModule} from "./tooltip/tooltip.module";
import {NgLegendComponent} from "./legend/legend.component";
import {NgAdvancedLegendComponent} from "./legend/advanced-legend.component";
import {NgScaleLegendComponent} from "./legend/scale-legend.component";
import {NgLegendEntryComponent} from "./legend/legend-entry.component";
import {NgTimelineComponent} from "./timeline/ng-timeline.component";
import {NgCountUpDirective} from "./count/count.directive";
import {SvgRadialGradientComponent} from "./svg-radial-gradient.component";
import {SvgLinearGradientComponent} from "./svg-linear-gradient.component";
import {NgAreaComponent} from "./area-component";
import {NgAreaTooltip} from "./area-tooltip.component";
import {NgCircleSeriesComponent} from "./circle-series.component";
import {NgAxesModule} from "./axes/ng-axes.module";
import {NgCircleComponent} from "./circle.component";
import {NgGridPanelComponent} from "./grid-panel.component";
import {NgGridPanelSeriesComponent} from "./grid-panel-series.component";

const COMPONENTS = [
    NgBaseChartComponent,
    NgChartComponent,
    NgAreaComponent,
    NgCircleSeriesComponent,
    NgCircleComponent,
    NgAreaTooltip,
    NgGridPanelComponent,
    NgGridPanelSeriesComponent,
    NgLegendComponent,
    NgScaleLegendComponent,
    NgAdvancedLegendComponent,
    NgLegendEntryComponent,
    NgTimelineComponent,
    NgCountUpDirective,
    SvgRadialGradientComponent,
    SvgLinearGradientComponent
];

@NgModule({
    providers: [
        Location,
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ],
    imports: [
        CommonModule,
        NgTooltipModule,
    ],
    declarations: [
        ...COMPONENTS
    ],
    exports: [
        CommonModule,
        NgTooltipModule,
        NgAxesModule,
        ...COMPONENTS,
    ]
})
export class NgChartsCommonModule {
}
